import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
const EXCEL_TYPE =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
@Injectable()
export class ExcelService {
  constructor() {}
  public exportAsExcelFile(
    json: any[],
    excelFileName: string,
    type: string
  ): void {
    if (type == 'exchange') {
      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
      console.log('worksheet', worksheet);

      const range = XLSX.utils.decode_range(worksheet['!ref']);

      // 데이터 행 1행으로 이동
      for (let col = range.s.c; col <= range.e.c; col++) {
        const srcCellAddress = XLSX.utils.encode_cell({
          r: range.s.r + 1,
          c: col,
        });
        const destCellAddress = XLSX.utils.encode_cell({
          r: range.s.r,
          c: col,
        });
        worksheet[destCellAddress] = worksheet[srcCellAddress];
        // delete worksheet[srcCellAddress];
      }

      const newRange = {
        s: { c: range.s.c, r: range.s.r }, // 시작 셀 설정
        e: { c: range.e.c, r: range.e.r - 1 }, // 끝 셀 설정
      };
      worksheet['!ref'] = XLSX.utils.encode_range(newRange); // 새로운 데이터 범위를 설정

      const workbook: XLSX.WorkBook = {
        Sheets: { data: worksheet },
        SheetNames: ['data'],
      };
      console.log('workbook', workbook);

      const excelBuffer: any = XLSX.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });

      this.saveAsExcelFile(excelBuffer, excelFileName);
    } else {
      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);

      const workbook: XLSX.WorkBook = {
        Sheets: { data: worksheet },
        SheetNames: ['data'],
      };

      const excelBuffer: any = XLSX.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });

      this.saveAsExcelFile(excelBuffer, excelFileName);
    }
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });

    FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
  }
}
